import { trackEvent } from "@pb/utils/tracking";
import { getLocale } from "@pb/utils/locale";
import { parseLocale } from "@pb/utils/locale";
import { isHmBrand } from "@pb/utils/brandConfig";
import { currentBrand } from "@pb/utils/brandConfig";
import { default as getCookie } from "@pb/utils/getCookie";
import { getTouchpoint } from "@pb/utils/touchpoint";
import trackingConstants from './trackingConstants';
const pageTrackingData = {};
export const trackFavouriteToggle = (data, articleCode, isFavorite = false, pageType, customTrackingData) => {
    var _a, _b, _c, _d;
    let brandSpecificTrackingData;
    const sharedTracking = {
        product_category: [(data === null || data === void 0 ? void 0 : data.category) || ''],
        product_currency: (data === null || data === void 0 ? void 0 : data.currency) || '',
    };
    if (!isHmBrand) {
        const getAttribute = (attribute) => { var _a; return (data === null || data === void 0 ? void 0 : data[attribute]) || (pageTrackingData === null || pageTrackingData === void 0 ? void 0 : pageTrackingData[attribute]) || ((_a = window.utag_data) === null || _a === void 0 ? void 0 : _a[attribute]) || ''; };
        brandSpecificTrackingData = {
            category_id: getAttribute('category_id') || '',
            category_path: getAttribute('category_path') || '',
            page_id: getAttribute('page_id') || '',
            page_type: pageType || 'pdp',
            region_locale: ((_a = getCookie('HMCORP_locale')) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '',
            region_market: window && window.getRegionMarket ? window.getRegionMarket().toLowerCase() : '',
            session_login_status: ((_b = document.getElementsByClassName('is-logged-in')) === null || _b === void 0 ? void 0 : _b.length) > 0 ? 'TRUE' : 'FALSE',
            session_touchpoint: getTouchpoint(),
            region_currency: ((_c = getCookie('HMCORP_currency')) === null || _c === void 0 ? void 0 : _c.toLowerCase()) || '',
            product_id: [articleCode || ''],
            product_name: [((data === null || data === void 0 ? void 0 : data.productTitle) && `${data.productTitle} | ${articleCode}`) || ''],
            product_brand: [
                (currentBrand === null || currentBrand === void 0 ? void 0 : currentBrand.toUpperCase()) === 'OTHERSTORIES'
                    ? 'STORIES'
                    : (currentBrand === null || currentBrand === void 0 ? void 0 : currentBrand.toUpperCase()) || '',
            ],
            product_price: [(data === null || data === void 0 ? void 0 : data.listPrice) || (data === null || data === void 0 ? void 0 : data.regularPriceValue) || ''],
            product_original_price: [(data === null || data === void 0 ? void 0 : data.regularPriceValue) || ''],
            product_color: [(data === null || data === void 0 ? void 0 : data.colorText) || ''],
            product_color_code: [(data === null || data === void 0 ? void 0 : data.colorCode) || ''],
        };
    }
    else {
        const language = getLocale('mixed');
        const market = ((_d = parseLocale(getLocale()).country) === null || _d === void 0 ? void 0 : _d.toUpperCase()) || '';
        brandSpecificTrackingData = {
            product_id: [articleCode ? `${articleCode}`.substr(0, 7) : ''],
            product_article_id: [articleCode || ''],
            product_name: [(data === null || data === void 0 ? void 0 : data.productTitle) || ''],
            product_brand: [(data === null || data === void 0 ? void 0 : data.brandName) || ''],
            product_color_code: [(data === null || data === void 0 ? void 0 : data.colorCode) || ''],
            product_discount: [(data === null || data === void 0 ? void 0 : data.discount) || ''],
            product_list_price: [(data === null || data === void 0 ? void 0 : data.listPrice) || ''],
            product_few_pieces: [(data === null || data === void 0 ? void 0 : data.fewPieces) || ''],
            product_original_price: [(data === null || data === void 0 ? void 0 : data.originalPrice) || ''],
            product_price_type: [(data === null || data === void 0 ? void 0 : data.priceType) || ''],
            product_size: [(data === null || data === void 0 ? void 0 : data.size) || ''],
            product_size_code: [(data === null || data === void 0 ? void 0 : data.sizeCode) || ''],
            selected_market: market,
            display_language: [language || ''],
        };
    }
    const generalFavouritesTrackingData = Object.assign(Object.assign(Object.assign(Object.assign({}, trackingConstants[isFavorite ? 'ADD_TO_FAVOURITES' : 'REMOVE_FROM_FAVOURITES']), sharedTracking), brandSpecificTrackingData), (customTrackingData && customTrackingData));
    trackEvent(generalFavouritesTrackingData, true, !!isHmBrand);
};
//# sourceMappingURL=tracking.js.map